import { useProjects } from "../features/projects/useProjects";

function LoginPage() {
    const { isLoading, projects } = useProjects();
    return (
        <div>
            <h1>Hello World!</h1>
            {!isLoading &&
                projects?.map((project) => {
                    return <h1>{project.title}</h1>;
                })}
        </div>
    );
}

export default LoginPage;
